import { templateTypes } from 'store/template';
import { CollectionTagPrefix } from './constants';

export function templateHasCollections(template: templateTypes.Template): boolean {
    return !!template.tags.some((tag) => tag.startsWith(CollectionTagPrefix));
}
